import { render, staticRenderFns } from "./modalslide2.vue?vue&type=template&id=1e590112&scoped=true&"
import script from "./modalslide2.vue?vue&type=script&lang=js&"
export * from "./modalslide2.vue?vue&type=script&lang=js&"
import style0 from "./modalslide2.vue?vue&type=style&index=0&id=1e590112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e590112",
  null
  
)

export default component.exports